/* eslint-disable */
import { produce } from "immer";
import {
  BENEFICIARY_FETCH_FAILURE,
  BENEFICIARY_FETCH_SUCCESS,
  BENEFICIARY_FETCH_START,
} from "../actions/types";

const beneficiary = (
  state = {
    beneficiaryFetching: false,
    beneficiaryData: [],
    beneficiaryError: null,
  },
  action,
) => {
  switch (action.type) {
    case BENEFICIARY_FETCH_START:
      return produce(state, (draft) => {
        draft.beneficiaryFetching = true;
      });
    case BENEFICIARY_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.beneficiaryFetching = true;
        draft.beneficiaryData = action.data;
        draft.beneficiaryFetching = false;
      });
    case BENEFICIARY_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.beneficiaryFetching = false;
        draft.beneficiaryError = action.error;
      });
    default:
      return state;
  }
};

export default beneficiary;
